export default __webpack_public_path__ + "afe9beb.png";